import api from "@/lib/axiosConfig";
import { Option } from "@/lib/types";
import { useMutation, useQuery } from "@tanstack/react-query";

async function getOptions(): Promise<Option[]> {
  const response = await api.get("/back/api/forfait-option");
  return response.data;
}

export const useGetOptions = () => {
  return useQuery({
    queryKey: ["options"],
    queryFn: getOptions,
  });
};

interface SubscribeOptionData {
  optionId: string;
  userId: string;
}

async function subscribeOption(data: SubscribeOptionData) {
  return await api.post("/back/api/mail/subscribe-option", data, {
    headers: {
      instance: localStorage.getItem("instance"),
    },
  });
}

export const useSubscribeOption = () => {
  return useMutation({
    mutationFn: subscribeOption,
  });
};
